import React, { useEffect, useState } from "react";

const BASE64EnDecode = () => {
  const [isEncoderVisible, setEncoderVisible] = useState(true);
  const [text, setText] = useState("");
  const [output, setOutput] = useState("");
  const [formatButtonClicked, setFormatButtonClicked] = useState(false);

  // DECODE text
  const decodeText = () => {
    try {
      let decodedText = decodeURIComponent(escape(atob(text)));
      setOutput(decodedText);
    } catch (error) {
      console.error("Error decoding:", error);
    }
  };

  // Toggle between encoder and decoder sections
  const encoderButton = () => {
    setEncoderVisible(true);
    setText(""); // clear the textfield when switching to encode-section
    setOutput(""); // clear the output field
  };

  const decoderButton = () => {
    setEncoderVisible(false);
    setText(""); // clear the textfield when switching to decode-section
    setOutput(""); // clear the output field
  };

  const handleFormatButtonClick = () => {
    setFormatButtonClicked(true);
  };

  const handleResetButtonClick = () => {
    setText("");
    setOutput("");
  };

  useEffect(() => {
    const encodeText = () => {
      let encodedText = btoa(unescape(encodeURIComponent(text)));
      setOutput(encodedText);
    };
  
    if (formatButtonClicked) {
      encodeText();
      setFormatButtonClicked(false);
    }
  }, [formatButtonClicked, text]);

  return (
      <main>
        <div className="container mt-4">
          <div className="d-flex justify-content-between">
            <h2>Base64 En/Decoder</h2>
            <div>
              <nav aria-label="Page navigation">
                <ul className="pagination">
                  <li
                      type="button"
                      className="page-item border p-2 roundedBtnLeft"
                      onClick={encoderButton}
                  >
                    Encoder
                  </li>
                  <li
                      type="button"
                      className="page-item border p-2 roundedBtnRight"
                      onClick={decoderButton}
                  >
                    Decoder
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          {isEncoderVisible ? (
              <section aria-labelledby="encoder-title">
                <h4 id="encoder-title" className="mt-3">Encoder</h4>
                <textarea
                    className="form-control w-75"
                    value={text}
                    aria-label="Encoder Input"
                    onChange={(e) => setText(e.target.value)}
                    cols="5"
                    rows="5"
                ></textarea>
                <button
                    type="button"
                    className="btn btn-secondary mt-2"
                    onClick={handleFormatButtonClick}
                >
                  Encode
                </button>
                <button
                    type="button"
                    className="btn btn-secondary mt-2 ms-2"
                    onClick={handleResetButtonClick}
                >
                  Reset
                </button>
                <h4 className="mt-3">Encoded String</h4>
                <textarea
                    className="form-control w-75"
                    value={output}
                    aria-label="Encoder Output"
                    id="output"
                    cols="5"
                    readOnly
                    rows="5"
                ></textarea>
              </section>
          ) : (
              <section aria-labelledby="decoder-title">
                <h4 id="decoder-title" className="mt-3">Decoder</h4>
                <textarea
                    className="form-control w-75"
                    value={text}
                    aria-label="Decoder Input"
                    onChange={(e) => setText(e.target.value)}
                    rows="5"
                ></textarea>
                <button
                    type="button"
                    className="btn btn-secondary mt-2"
                    onClick={decodeText}
                >
                  Decode
                </button>
                <button
                    type="button"
                    className="btn btn-secondary mt-2 ms-2"
                    onClick={handleResetButtonClick}
                >
                  Reset
                </button>
                <h4 className="mt-3">Decoded String</h4>
                <textarea
                    id="output"
                    className="form-control w-75"
                    value={output}
                    aria-label="Decoder Output"
                    readOnly
                    rows="5"
                ></textarea>
              </section>
          )}
        </div>
      </main>
  );
};

export default BASE64EnDecode;
